<div class="overlay-wrapper fw fh"
    [hidden]="!showLoader">
    <mat-progress-spinner class="spc-spinner"
        mode="indeterminate"></mat-progress-spinner>
</div>